































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IRouteInfo, IRouteCity } from "@/@types/routeInfo/route-info";

import RouteListCitysDataTable from "@/components/tables/route-info/route-list-citys-data.vue";
import SubmitResetButtonGroop from "../../buttons/submit-reset-button-groop.vue";
import ChangeDeliteButtons from "../../buttons/change-delite-buttons.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

@Component({
  components: {
    BSwitch,
    ChangeDeliteButtons,
    SubmitResetButtonGroop,
    RouteListCitysDataTable,
  },
})
export default class FullRouteInfoList extends Vue {
  @Prop({ type: Array, default: () => [] }) routeList!: Array<IRouteInfo>;
  @Prop({ type: Array, default: () => [] }) cityList!: Array<IRouteCity>;
  @Prop({ type: Boolean, default: false }) auto!: boolean;
  @Prop({ type: String, default: "" }) activeRoute!: string;

  id = "";

  quickChangeNotes = false;
  notes = "";
  notesID: string | undefined = "";

  onReset(): void {
    this.notes = "";
    this.notesID = "";
    this.quickChangeNotes = false;
  }

  async onSubmit(event: HTMLFormElement): Promise<void> {
    event.preventDefault();
    this.$emit("changeRoute", this.notesID, { notes: this.notes });
    this.notes = "";
    this.notesID = undefined;
    this.quickChangeNotes = false;
  }

  async changeActive(id: string | undefined, toggle: boolean): Promise<void> {
    if (!id) return;
    if (this.activeRoute == id)
      try {
        const result = await this.$bvModal.msgBoxConfirm(
          String(this.$i18n.t("main.confirms.ok")),
          {
            title: String(this.$i18n.t("RouterInfo.RouteList.confirm")),
          }
        );

        if (!result) return;
      } catch {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.empty400")),
          type: "warn",
        });
      }
    if (this.activeRoute && this.activeRoute != id)
      this.$emit("changeRoute", this.activeRoute, { active: false });
    this.$nextTick(() => {
      this.$emit("changeRoute", id, { active: toggle });
    });
  }

  changeRouteEvent(id: string, event: boolean): void {
    if (event) {
      this.$router.push({ name: "AddRoute", params: { id: id } });
      return;
    }
    this.$emit("deleteRoute", id);
  }
}
